import React from "react";
import Select from "react-select";
import { ValidatorComponent } from "react-form-validator-core";

class SelectValidator extends ValidatorComponent {
    errorText() {
        const { isValid } = this.state;

        if (isValid) {
            return null;
        }

        return <span className="textValidatorError">{this.getErrorMessage()}</span>;
    }

    renderValidatorComponent() {
        const { errorMessages, validators, requiredError, validatorListener, isDisabled, ...rest } = this.props;
        return (
            <>
                <Select
                    {...rest}
                    ref={(r) => {
                        this.input = r;
                    }}
                    isSearchable={false}
                    isClearable={false}
                    isDisabled={isDisabled}
                />
                {this.errorText()}
            </>
        );
    }
}

export default SelectValidator;
